import Vendor from "./Vendor";
import { Button, Flex } from 'antd';

export default function VendorList({ items, vendors, handleOnchangeItemPrice, handleOnchangeVendor, deleteVendor, formStatus, form }) {
    return (
        <>
            {vendors.map((vendor, index) => (
                <Vendor
                    key={vendor.id}
                    vendorIndex={index}
                    items={vendor.items}
                    vendor={vendor}
                    handleOnchangeItemPrice={handleOnchangeItemPrice} 
                    handleOnchangeVendor={handleOnchangeVendor}
                    deleteVendor={deleteVendor}
                    formStatus={formStatus}
                    form={form}
                />
            ))}
        </>
    )
}